import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_NAME = 'Ivy League Consulting';
const SITE_URL = 'https://ivyleagueconsulting.org';
const DEFAULT_TITLE_SUFFIX = 'Elite College Admissions Strategy by Former Harvard Interviewers';
const DEFAULT_DESC = 'Former Harvard admissions interviewers building your Ivy League application with case-level precision. Strategic positioning, essay architecture, and multi-advisor review.';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

// Assemble a title without duplicating the site-name suffix.
function buildTitle(title) {
  if (!title) return `${SITE_NAME} | ${DEFAULT_TITLE_SUFFIX}`;
  const lower = title.toLowerCase();
  const alreadyBranded = lower.includes(SITE_NAME.toLowerCase());
  return alreadyBranded ? title : `${title} | ${SITE_NAME}`;
}

export function SEO({
  title,
  description,
  path,             // optional override; defaults to current pathname
  image,            // optional og:image override
  keywords,         // optional keywords string
  schema,           // optional JSON-LD object or array of objects
  noindex = false,
}) {
  const location = useLocation();
  const pathname = path || (location && location.pathname) || '/';
  const canonical = `${SITE_URL}${pathname === '/' ? '/' : pathname}`;
  const fullTitle = buildTitle(title);
  const desc = description || DEFAULT_DESC;
  const ogImage = image || DEFAULT_OG_IMAGE;

  const schemaArray = Array.isArray(schema) ? schema : schema ? [schema] : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {schemaArray.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
